import api from "../api";

export const getHomeownerJobs = async (type = 'unpaid') => {
    const res = await api.get(`/job/getHomeownerJobsByPaymentStatus?type=${type}`);
    return res.data;
}